import { useRef } from "react";

const useScrollToElement = () => {
  const ref = useRef<HTMLDivElement>(null);

  const scrollToElement = () => {
    const element = ref.current;

    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return { ref, scrollToElement };
};

export { useScrollToElement };
